export default "__VITE_ASSET__BaNZlvoM__"